/**
 * CoachForce CRM - Main Entry Point
 *
 * This is the main JavaScript entry point for the application.
 * It initializes core services and exports them globally for
 * compatibility with existing code.
 */

// Core Services
import { api, ApiError } from '@services/api.js';
import { athleteService } from '@services/athletes.js';
import { invoiceService } from '@services/invoices.js';

// Utilities
import * as utils from '@utils/index.js';

// Initialize logging
console.info('CoachForce CRM v1.0 - Frontend initialized');

// Export services globally for backwards compatibility
window.CoachForceAPI = {
  api,
  ApiError,
  athletes: athleteService,
  invoices: invoiceService,
};

// Export utilities globally
window.CoachForceUtils = utils;

// Re-export for ES module usage
export { api, ApiError, athleteService, invoiceService, utils };
